import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { GetService } from "../../../Services/ConstantService";
import { API_URL } from "../../../Services/ApiService";
import BounceLoader from "react-spinners/BounceLoader";

export default function Layout() {
  let [loading, setLoading] = useState(true);
  const [LayoutList, setLayoutList] = useState([]);
  const [LayoutId, setLayoutId] = useState([]);


  useEffect(() => {
    GetList();
  }, []);

  useEffect(() => {
   console.log(LayoutId)
  }, [LayoutId]);

  function GetList() {
    setLoading(true);
    GetService(API_URL.GET_LAYOUT_LIST).then((res) => {
      console.log(res);
      if (res?.data?.status === true) {
        setLayoutList(res?.data?.data);
      }
      setLoading(false);
    });
  }

  return (
    <>
      <div
        className="tab-pane fade  active show"
        id="pills-tab2"
        role="tabpanel"
        aria-labelledby="pills-Tab2-tab"
      >
        <div className="row mt-20 mb-10">
          <div className="col-xl-12 col-lg-12 col-md-12 ">
            <h6 className=" heading">Layout</h6>
          </div>
        </div>
        <div className="content-section layout">
          <div className="row unselect">
            <h6 className="heading mt-4 mb-4">Choose Your Layout</h6>
            {LayoutList &&
              LayoutList.map((list, i) => {
                return (
                  <div key={i}
                    className="col-xl-6 col-lg-6 col-md-6 col-sm-12"
                    style={{ paddingRight: 7 }}
                  >
                    <Link to={`/create-print/size/${list?.id}`} onClick={()=>setLayoutId(list?.id)}>
                      <div className="tp-catagori-2__content-box mb-15">
                        <div className="tp-catagori-2__content plr text-center">
                          <img
                            className="w-32"
                            src="assets/img/blog/single_canvas.png"
                            alt=""
                          />
                          <h4 className="tp-catagori-2__title text-white">
                            {list?.name}
                          </h4>
                          <p>
                           {list?.description}
                          </p>
                        </div>
                      </div>
                    </Link>
                  </div>
                );
              })}
          </div>
        </div>
      </div>
    </>
  );
}
